import CommonLayout from 'components/CommonLayout';
import Body from 'containers/AgentPage/body';
import messages from 'containers/SiteMapPage/messages';
import { AssuranceIcon } from 'images';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getAgents } from 'store/geolocAgent/actions';
import { getAgentSelector } from 'store/geolocAgent/selectors';
import { uppercase } from 'utils/string';
import { isEmpty } from 'lodash';

const AgentPage = ({
  getAgents,
  agentInfo,
}: {
  getAgents: Function;
  agentInfo: {
    AGT_SURN: string;
    AGT_PHYS_ADD1: string;
    PROVINCE: string;
    HORAIRE_LUNDI_JEUDI_APRES_MIDI: string;
    HORAIRE_LUNDI_JEUDI_MATIN: string;
    HORAIRE_VENDREDI_APRES_MIDI: string;
    HORAIRE_VENDREDI_MATIN: string;
    HORAIRE_SAMEDI: string;
    FAX: string;
    AGT_EMAIL: string;
    LATITUDE: string;
    LONGITUDE: string;
  };
}) => {
  useEffect(() => {
    getAgents();
    // eslint-disable-next-line
  }, []);
  return (
    <CommonLayout
      content={
        <Body
          nameAgent={
            agentInfo && !isEmpty(agentInfo.AGT_SURN)
              ? uppercase(agentInfo.AGT_SURN)
              : ''
          }
          AdresseAgent={
            agentInfo && !isEmpty(agentInfo.AGT_PHYS_ADD1)
              ? uppercase(agentInfo.AGT_PHYS_ADD1)
              : ''
          }
          villeAgent={
            agentInfo && !isEmpty(agentInfo.PROVINCE)
              ? uppercase(agentInfo.PROVINCE)
              : ''
          }
          horaireLundiJeudi={
            (agentInfo && !isEmpty(agentInfo.HORAIRE_LUNDI_JEUDI_MATIN)) ||
            (agentInfo && !isEmpty(agentInfo.HORAIRE_LUNDI_JEUDI_APRES_MIDI))
              ? agentInfo.HORAIRE_LUNDI_JEUDI_MATIN +
                ' ' +
                agentInfo.HORAIRE_LUNDI_JEUDI_APRES_MIDI
              : ''
          }
          horaireVendredi={
            (agentInfo && !isEmpty(agentInfo.HORAIRE_VENDREDI_MATIN)) ||
            (agentInfo && !isEmpty(agentInfo.HORAIRE_VENDREDI_APRES_MIDI))
              ? agentInfo.HORAIRE_VENDREDI_MATIN +
                ' ' +
                agentInfo.HORAIRE_VENDREDI_APRES_MIDI
              : ''
          }
          horaireSamedi={agentInfo && agentInfo.HORAIRE_SAMEDI}
          phone={agentInfo && agentInfo.FAX}
          email={agentInfo && agentInfo.AGT_EMAIL}
          marker={[
            {
              icon: AssuranceIcon.check_auto_express,
              position: {
                lat: agentInfo && parseFloat(agentInfo.LATITUDE),
                lng: agentInfo && parseFloat(agentInfo.LONGITUDE),
              },
            },
          ]}
        />
      }
      fullscreen={true}
      icon={<img alt="" src={AssuranceIcon['localiserAgentIcon']} />}
      title={messages.agent}
    ></CommonLayout>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    agentInfo: {
      AGT_SURN: string;
      AGT_PHYS_ADD1: string;
      PROVINCE: string;
      HORAIRE_LUNDI_JEUDI_APRES_MIDI: string;
      HORAIRE_LUNDI_JEUDI_MATIN: string;
      HORAIRE_VENDREDI_APRES_MIDI: string;
      HORAIRE_VENDREDI_MATIN: string;
      HORAIRE_SAMEDI: string;
      FAX: string;
      AGT_EMAIL: string;
      LATITUDE: string;
      LONGITUDE: string;
    };
  }
>({
  agentInfo: getAgentSelector,
});
const mapDispatchToProps = {
  getAgents,
};
export default connect(mapStateToProps, mapDispatchToProps)(AgentPage);
export { AgentPage as AgentPageTest };
